var React = require('react');

function ContentMountain (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Mountain"),React.createElement("path",{"d":"M31.5,14.6l28.2,45.2c0.5,0.9,0.3,2-0.6,2.5c-0.3,0.2-0.6,0.3-0.9,0.3H1.8c-1,0-1.8-0.8-1.8-1.8c0-0.3,0.1-0.7,0.3-1\n\tl28.2-45.2c0.5-0.8,1.6-1.1,2.5-0.5C31.2,14.2,31.4,14.4,31.5,14.6z M96.2,59.7L80.3,34.3c-0.6-0.9-1.7-1.1-2.6-0.5\n\tc-0.2,0.1-0.4,0.3-0.5,0.5l-3.7,6L48.9,0.8c-0.6-0.9-1.7-1.1-2.6-0.5c-0.2,0.1-0.4,0.3-0.5,0.5l-9.4,15l26.3,42.1\n\tc0.9,1.4,1,3.1,0.5,4.7h31.4c1.1,0,1.9-0.8,1.9-1.9C96.5,60.4,96.4,60,96.2,59.7z","key":1})]);
}

ContentMountain.defaultProps = {"role":"presentation","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 96.5 62.6","style":{"enableBackground":"new 0 0 96.5 62.6"},"xmlSpace":"preserve"};

module.exports = ContentMountain;

ContentMountain.default = ContentMountain;
